@let widgetRefId = widgetStore.refIdSg();
@let chartIds = chartIdsSg();
@let hasProposal =
  treeEditorFeature.selectors.hasProposal({ widgetRefId }).asSignal();

<div class="atn-summit-organization-page">
  @if (hasProposal) {
    <atn-ds-integrated-horizontal-tabs
      class="atn-summit-organization-page__tabs"
    >
      <ng-template
        atnDsTab
        name="Current Chart"
      >
        <div class="atn-summit-organization-page__tab-content">
          <atn-tree-editor-chart
            class="atn-summit-organization-page__org-chart"
            [chartId]="chartIds.current"
          />
        </div>
      </ng-template>

      <ng-template
        atnDsTab
        [isInitiallySelected]="true"
        name="Proposed Chart"
      >
        <div class="atn-summit-organization-page__tab-content">
          <atn-tree-editor-chart
            class="atn-summit-organization-page__org-chart"
            [chartId]="chartIds.proposed"
          />
        </div>
      </ng-template>
    </atn-ds-integrated-horizontal-tabs>
  } @else {
    <atn-tree-editor-chart
      class="atn-summit-organization-page__org-chart"
      [chartId]="chartIds.current"
    />
  }
</div>
